import httpService from '../httpService'

export function login(phone: string, password: string) {
  return httpService.post('/v9/content-dashboard/auth/login/', {
    phone,
    password,
  })
}

export interface MfaVerifyRequest {
  mfaId: string
  mfaMethod: string
  code: string
  newPassword?: string
  confirmPassword?: string
}

export function verifyMfa(payload: MfaVerifyRequest) {
  return httpService.post('/v9/content-dashboard/auth/mfa/verify/', {
    mfa_id: payload.mfaId,
    mfa_method: payload.mfaMethod,
    code: payload.code,
    ...(payload.newPassword && { new_password: payload.newPassword }),
    ...(payload.confirmPassword && { confirm_password: payload.confirmPassword }),
  })
}

export interface ForgotPasswordRequest {
  phone: string
  code: string
  newPassword: string
  confirmPassword: string
}

export function forgotPassword(payload: ForgotPasswordRequest) {
  return httpService.post('/v9/content-dashboard/auth/password/reset/', {
    phone: payload.phone,
    code: payload.code,
    new_password: payload.newPassword,
    confirm_password: payload.confirmPassword,
  })
}

export interface ChangePasswordRequest {
  currentPassword: string
  newPassword: string
  confirmPassword: string
  code: string
}

export function changePassword(payload: ChangePasswordRequest) {
  return httpService.post('/v9/content-dashboard/auth/password/change/', {
    current_password: payload.currentPassword,
    new_password: payload.newPassword,
    confirm_password: payload.confirmPassword,
    code: payload.code,
  })
}

export function logout() {
  return httpService.post('/v4/content/logout/')
}
